import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=3727be6e&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=ts"
export * from "./PostEdit.vue?vue&type=script&lang=ts"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=3727be6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727be6e",
  null
  
)

export default component.exports